import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { ErrorHandler } from '@helper/errorHandler';
import { IPRecommendationKAEDataType } from '@components/contractor360KAE/components/siteLeadOverviewKAE';

export interface IPRecommendationKAEResponse {
	products: IPRecommendationKAEDataType[];
}

export const usePRecommendationKAEQuery = (siteId: string): IQueryResponse<IPRecommendationKAEResponse> => {
	const fetchRecommendedProducts = async (): Promise<IPRecommendationKAEResponse> => {
		try {
			return await APIService.getData<IPRecommendationKAEResponse>(
				`${APICONFIG.PRODUCT_RECOMMENDATION_LIST_KAE}?site_id=${siteId}`
			);
		} catch (error) {
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['PRecommendationKAE', siteId],
		queryFn: fetchRecommendedProducts,
		enabled: !!siteId,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
